import React, { Component } from 'react'
import { motion } from 'framer-motion'
import * as XLSX from 'xlsx'
import { jsPDF } from 'jspdf'
import ServiceSubPageHeader from './ServiceSubPageHeader'
import FilterChip from '../UI/FilterChip'
import OnlyPremiumEmpty from '../UI/OnlyPremiumEmpty'
import PremiumAlert from '../UI/PremiumAlert'

class ServiceCommandesAll extends Component {

	constructor(props) {
		super(props)
		const now = new Date()
		now.setHours(0, 0, 0, 0)
		const pad = n => String(n).padStart(2, '0')
		this.state = {
			date: Math.floor(now.getTime() / 1000),
			nav_center_day: pad(now.getDate()),
			nav_center_month: pad(now.getMonth() + 1),
			nav_center_year: String(now.getFullYear()),
			range_mode: false,
			range_start_day: pad(now.getDate()),
			range_start_month: pad(now.getMonth() + 1),
			range_start_year: String(now.getFullYear()),
			range_end_day: pad(now.getDate()),
			range_end_month: pad(now.getMonth() + 1),
			range_end_year: String(now.getFullYear()),
			available_years: [String(now.getFullYear())],
			tile_counts: {},
			reservations: [],
			service_benefits: [],
			clients: [],
			panel: null,
			uncancelledIds: new Set(),
			serviceFilter: null,
			slotFilter: null,
			showCancelled: false,
			loading: true,
			addModal: false,

			// Modal ajout commande
			addStep: 1,
			addService: null,
			addBenefit: null,
			addDay: null,
			addSlot: null,
			addWeekOffset: 0,
			addCart: [],
			addProducts: [],
			addForm: { client_number: '', firstname: '', lastname: '', phone: '', pitch: '', comment: '', answers: [] },
			addClient: null,
			addError: null,
			addSuccess: null,
			addLoading: false,

			// Modal édition commande
			editModal: false,
			editReservation: null,
			editDay: null,
			editWeekOffset: 0,
			editSlot: null,
			editCart: [],
			editProducts: [],
			editBenefit: null,
			editForm: { client_number: '', firstname: '', lastname: '', phone: '', pitch: '', comment: '' },
			editLoading: false,
			editError: null,

			// Modal confirmation annulation
			cancelModal: false,
			cancelTargetId: null,
			cancelClosePanel: null,
			cancellingId: null,
		}
		this.pollTimer = null
		// ids des commandes déjà affichées — null tant que le premier chargement n'a pas abouti,
		// pour ne jamais notifier le contenu initial de la page
		this.knownReservationIds = null
	}

	componentDidMount() {
		if (this.props.updateNavbarTitle)
			this.props.updateNavbarTitle('Commandes')
		// notif navigateur : demande la permission une fois (best-effort, comme la Messagerie)
		if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'default')
		{
			try { Notification.requestPermission() }
			catch (e) { /* certains navigateurs exigent un geste utilisateur : ignoré */ }
		}
		Promise.all([
			this.props.fetchClients ? this.props.fetchClients() : Promise.resolve([]),
			this.props.fetchWebappUsers ? this.props.fetchWebappUsers() : Promise.resolve([]),
			this.props.fetchServiceBenefits ? this.props.fetchServiceBenefits() : Promise.resolve([]),
		]).then(([clients, , benefits]) => {
			this.setState({ clients: clients || [], service_benefits: benefits || [] }, () => this._loadReservations())
		}).catch(() => this._loadReservations())
		this.pollTimer = setInterval(this._pollReservations, 15000)
	}

	componentWillUnmount() {
		if (this.pollTimer)
			clearInterval(this.pollTimer)
	}

	// Récupère les réservations de la fenêtre de dates courante, filtrées sur les services "vente"
	_fetchReservations = () => {
		const { date, range_mode, range_start_day, range_start_month, range_start_year,
			range_end_day, range_end_month, range_end_year } = this.state
		let start = date
		let end = date + 86400
		if (range_mode)
		{
			start = Math.floor(new Date(parseInt(range_start_year), parseInt(range_start_month) - 1, parseInt(range_start_day)).getTime() / 1000)
			end = Math.floor(new Date(parseInt(range_end_year), parseInt(range_end_month) - 1, parseInt(range_end_day) + 1).getTime() / 1000)
		}
		const servicesPromise = (this.props.services && this.props.services.length > 0)
			? Promise.resolve(this.props.services)
			: (this.props.fetchServices ? this.props.fetchServices() : Promise.resolve([]))
		return Promise.all([
			this.props.fetchReservationsByDateRange(start, end),
			servicesPromise
		])
		.then(([reservations, services]) => {
			const venteIds = new Set((services || []).filter(s => s.type === 'vente').map(s => String(s._id)))
			return (reservations || []).filter(r => {
				const sid = String(typeof r.service === 'object' ? r.service._id : r.service)
				return venteIds.has(sid)
			})
		})
	}

	_loadReservations = () => {
		this.setState({ loading: true })
		this._fetchReservations()
		.then(filtered => {
			// nouveau point de référence : un changement de date ne déclenche pas de notification
			this.knownReservationIds = new Set(filtered.map(r => String(r._id)))
			this.setState({ reservations: filtered, loading: false })
			if (!this.state.range_mode)
				this._loadTileCounts()
		})
		.catch(() => this.setState({ loading: false }))
	}

	// Rafraîchissement silencieux périodique : les nouvelles commandes tombent en temps réel,
	// sans spinner ni rechargement de page (même principe que le polling de la Messagerie)
	_pollReservations = () => {
		this._fetchReservations()
		.then(filtered => {
			const known = this.knownReservationIds
			const fresh = (known === null) ? [] : filtered.filter(r => !r.cancelled && !known.has(String(r._id)))
			this.knownReservationIds = new Set(filtered.map(r => String(r._id)))
			this.setState({ reservations: filtered })
			if (!this.state.range_mode)
				this._loadTileCounts()
			if (fresh.length > 0)
				this._notifyNewReservations(fresh)
		})
		.catch(() => {})
	}

	// Notif navigateur à l'arrivée de nouvelles commandes (même principe que la Messagerie)
	_notifyNewReservations = (fresh) => {
		if (typeof window === 'undefined' || !('Notification' in window) || Notification.permission !== 'granted')
			return
		try
		{
			const first = fresh[0]
			const title = (fresh.length > 1)
				? (fresh.length + ' nouvelles commandes')
				: 'Nouvelle commande'
			const body = (fresh.length > 1)
				? 'Plusieurs commandes viennent d\'arriver'
				: ((this._getClientName(first) || 'Un client') + ' — ' + this._getServiceName(first))
			const notif = new Notification(title, { body: body, tag: 'pocketcamp-commandes' })
			notif.onclick = () => {
				try { window.focus() } catch (e) {}
				notif.close()
			}
		}
		catch (e) { /* échec silencieux */ }
	}

	// ─── Navigation date ─────────────────────────────────────────────────────────

	_getTodayParts = () => {
		const now = new Date()
		const pad = n => String(n).padStart(2, '0')
		return { day: pad(now.getDate()), month: pad(now.getMonth() + 1), year: String(now.getFullYear()) }
	}

	_shiftWeek = (delta) => {
		const { nav_center_day, nav_center_month, nav_center_year } = this.state
		const d = new Date(parseInt(nav_center_year), parseInt(nav_center_month) - 1, parseInt(nav_center_day))
		d.setDate(d.getDate() + delta * 5)
		const pad = n => String(n).padStart(2, '0')
		this.setState({
			nav_center_day: pad(d.getDate()),
			nav_center_month: pad(d.getMonth() + 1),
			nav_center_year: String(d.getFullYear())
		}, () => this._loadTileCounts())
	}

	_loadTileCounts = () => {
		const { nav_center_day, nav_center_month, nav_center_year } = this.state
		const center = new Date(parseInt(nav_center_year), parseInt(nav_center_month) - 1, parseInt(nav_center_day))
		const from = new Date(center)
		from.setDate(center.getDate() - 2)
		from.setHours(0, 0, 0, 0)
		const to = new Date(center)
		to.setDate(center.getDate() + 3)
		to.setHours(0, 0, 0, 0)
		const start = Math.floor(from.getTime() / 1000)
		const end = Math.floor(to.getTime() / 1000)
		const servicesPromise = (this.props.services && this.props.services.length > 0)
			? Promise.resolve(this.props.services)
			: (this.props.fetchServices ? this.props.fetchServices() : Promise.resolve([]))
		Promise.all([
			this.props.fetchReservationsByDateRange(start, end),
			servicesPromise
		])
		.then(([reservations, services]) => {
			const venteIds = new Set((services || []).filter(s => s.type === 'vente').map(s => String(s._id)))
			const counts = {}
			for (const r of (reservations || []))
			{
				if (r.cancelled) continue
				const sid = String(typeof r.service === 'object' ? r.service._id : r.service)
				if (!venteIds.has(sid)) continue
				const d = new Date(r.start * 1000)
				const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
				counts[key] = (counts[key] || 0) + 1
			}
			this.setState({ tile_counts: counts })
		})
		.catch(() => {})
	}

	_shiftRange = (delta) => {
		const { range_start_day, range_start_month, range_start_year,
			range_end_day, range_end_month, range_end_year } = this.state
		const start = new Date(`${range_start_year}-${range_start_month}-${range_start_day}`)
		const end = new Date(`${range_end_year}-${range_end_month}-${range_end_day}`)
		start.setDate(start.getDate() + delta)
		end.setDate(end.getDate() + delta)
		const pad = n => String(n).padStart(2, '0')
		this.setState({
			range_start_day: pad(start.getDate()),
			range_start_month: pad(start.getMonth() + 1),
			range_start_year: String(start.getFullYear()),
			range_end_day: pad(end.getDate()),
			range_end_month: pad(end.getMonth() + 1),
			range_end_year: String(end.getFullYear())
		})
	}

	_formatDate = (ts) => {
		const d = new Date(ts * 1000)
		const days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']
		const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
		return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]
	}

	_formatTime = (ts) => {
		const d = new Date(ts * 1000)
		const h = String(d.getHours()).padStart(2, '0')
		const m = String(d.getMinutes()).padStart(2, '0')
		return h + 'h' + m
	}

	_formatEur = (amount) => {
		return amount.toFixed(2).replace('.', ',') + ' €'
	}

	// ─── Données calculées ───────────────────────────────────────────────────────

	_getVenteServices = () => {
		return (this.props.services || []).filter(s => s.type === 'vente')
	}

	_getFilteredReservations = () => {
		const { reservations, serviceFilter, uncancelledIds } = this.state
		return reservations.filter(r => {
			if (r.cancelled && !uncancelledIds.has(String(r._id))) return false
			if (serviceFilter === null) return true
			const sid = String(typeof r.service === 'object' ? r.service._id : r.service)
			return sid === String(serviceFilter)
		})
	}

	_getCancelledReservations = () => {
		const { reservations, serviceFilter, uncancelledIds } = this.state
		return reservations.filter(r => {
			if (!r.cancelled || uncancelledIds.has(String(r._id))) return false
			if (serviceFilter === null) return true
			const sid = String(typeof r.service === 'object' ? r.service._id : r.service)
			return sid === String(serviceFilter)
		})
	}

	_getClientName = (r) => {
		if (r.firstname || r.lastname)
			return ((r.firstname || '') + ' ' + (r.lastname || '')).trim()
		if (r.user && typeof r.user === 'object') {
			const name = ((r.user.firstname || '') + ' ' + (r.user.lastname || '')).trim()
			if (name) return name
		}
		if (r.identity) return r.identity
		if (r.client_number) {
			const c = (this.state.clients || []).find(c => c.client_number === r.client_number)
			if (c) return ((c.firstname || '') + ' ' + (c.lastname || '')).trim()
			return '#' + r.client_number
		}
		return 'Campeur inconnu'
	}

	_getClientNumber = (r) => {
		if (r.client_number) return '#' + r.client_number
		if (r.user && typeof r.user === 'object' && r.user.client_number) return '#' + r.user.client_number
		return null
	}

	_getArticleName = (item) => {
		const lang = this.props.lang_default || 'fr'
		if (!item.translations) return item.name || item.subtitle || item.title || 'Article'
		const t = item.translations.find(t => t.lang === lang) || item.translations[0]
		return t ? (t.title || t.subtitle || t.name || 'Article') : 'Article'
	}

	_getServiceName = (r) => {
		const sid = String(typeof r.service === 'object' ? r.service._id : r.service)
		const service = this._getVenteServices().find(s => String(s._id) === sid)
		return service ? service.name : '—'
	}

	_aggregateByArticle = (reservations) => {
		const map = {}
		for (const r of reservations) {
			if (!r.cart) continue
			for (const item of r.cart) {
				const key = String(item._id)
				if (!map[key])
					map[key] = { id: key, name: this._getArticleName(item), quantity: 0 }
				map[key].quantity += Number(item.quantity) || 0
			}
		}
		return Object.values(map).sort((a, b) => b.quantity - a.quantity)
	}

	_groupBySlot = (reservations) => {
		const map = {}
		for (const r of reservations) {
			const key = r.start
			if (!map[key]) map[key] = { time: r.start, reservations: [] }
			map[key].reservations.push(r)
		}
		return Object.values(map).sort((a, b) => a.time - b.time)
	}

	_getCartTotal = (r) => {
		if (!r.cart) return 0
		return r.cart.reduce((sum, item) => sum + (Number(item.price) || 0) * (Number(item.quantity) || 0), 0)
	}

	_getDayTotal = (reservations) => {
		return reservations.reduce((sum, r) => sum + this._getCartTotal(r), 0)
	}

	_getSlotRemaining = (slot) => {
		return slot.reservations.filter(r => !r.served).length
	}

	// ─── Statut servi ────────────────────────────────────────────────────────────

	_toggleServed = (id, e) => {
		e.stopPropagation()
		const r = this.state.reservations.find(r => String(r._id) === String(id))
		if (!r) return
		const newServed = !r.served
		const reservations = this.state.reservations.map(res =>
			String(res._id) === String(id) ? { ...res, served: newServed } : res
		)
		this.setState({ reservations })
		if (this.props.serveServiceReservation)
			this.props.serveServiceReservation(String(id), newServed)
	}

	_togglePaid = (id, e) => {
		e.stopPropagation()
		const r = this.state.reservations.find(r => String(r._id) === String(id))
		if (!r) return
		// Paiement CB in-app : statut définitif, non modifiable par le staff.
		if (r.paid_by === 'stripe') return
		const newPaid = !r.paid
		const reservations = this.state.reservations.map(res =>
			String(res._id) === String(id) ? { ...res, paid: newPaid } : res
		)
		this.setState({ reservations })
		if (this.props.payServiceReservation)
			this.props.payServiceReservation(String(id), newPaid)
	}

	_toggleUncancel = (id) => {
		const uncancelledIds = new Set(this.state.uncancelledIds)
		if (uncancelledIds.has(String(id)))
			uncancelledIds.delete(String(id))
		else
			uncancelledIds.add(String(id))
		this.setState({ uncancelledIds })
	}

	// ─── Annulation ──────────────────────────────────────────────────────────────

	_cancel = (id) => {
		this.props.cancelServiceReservation(id)
		.then(() => this._loadReservations())
		.catch(() => this._loadReservations())
	}

	// ─── Export CSV ──────────────────────────────────────────────────────────────

	_downloadXlsx = () => {
		const active = this._getFilteredReservations()
		const lang = this.props.lang_default || 'fr'
		const benefitsPromise = this.props.fetchServiceBenefits ? this.props.fetchServiceBenefits() : Promise.resolve([])
		benefitsPromise.then(service_benefits => {
			this.setState({ service_benefits: service_benefits || [] })

			// Résout le benefit d'une réservation : via service_benefit si dispo,
			// sinon via le service parent (cas vente sans créneaux)
			const resolveBenefit = (r) => {
				const bId = (r.service_benefit && r.service_benefit._id) ? String(r.service_benefit._id) : (r.service_benefit ? String(r.service_benefit) : null)
				if (bId)
					return { benefit: (service_benefits || []).find(b => String(b._id) === bId) || null, bId }
				const sId = typeof r.service === 'object' ? String(r.service._id) : String(r.service)
				const fallback = (service_benefits || []).find(b => String(b.service) === sId) || null
				return { benefit: fallback, bId: fallback ? String(fallback._id) : null }
			}

			// Collecte toutes les questions uniques à travers les réservations
			const questionCols = []
			const questionKeySet = new Set()
			for (const r of active) {
				const { benefit, bId } = resolveBenefit(r)
				if (!benefit || !benefit.questions || !bId) continue
				benefit.questions.forEach((q, idx) => {
					const key = bId + '_' + idx
					if (questionKeySet.has(key)) return
					questionKeySet.add(key)
					const t = (q.translations || []).find(t => t.lang === lang) || (q.translations || [])[0]
					questionCols.push({ key, bId, idx, label: t ? t.title : ('Q' + (idx + 1)) })
				})
			}

			// ── Feuille Détail ───────────────────────────────────────────────
			const detailHeaders = ['Service', 'Date', 'Heure', 'Prénom / Nom', 'N° client', 'Article', 'Quantité', 'Prix unitaire (€)', 'Total panier (€)', ...questionCols.map(q => q.label)]
			const detailRows = [detailHeaders]
			for (const r of active) {
				if (!r.cart) continue
				const { bId } = resolveBenefit(r)
				const d = new Date(r.start * 1000)
				const date = String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + d.getFullYear()
				const heure = this._formatTime(r.start)
				const name = this._getClientName(r)
				const num = this._getClientNumber(r) || ''
				const total = this._getCartTotal(r)
				const serviceName = this._getServiceName(r)
				const answers = questionCols.map(q => {
					if (q.bId !== String(bId)) return ''
					return (r.answers && r.answers[q.idx] != null) ? r.answers[q.idx] : ''
				})
				r.cart.forEach((item, i) => {
					const qty = Number(item.quantity) || 0
					const price = Number(item.price) || 0
					const isFirst = i === 0
					detailRows.push([
						isFirst ? serviceName : '',
						isFirst ? date : '',
						isFirst ? heure : '',
						isFirst ? name : '',
						isFirst ? num : '',
						this._getArticleName(item),
						qty,
						price,
						isFirst ? total : '',
						...answers.map(a => isFirst ? a : ''),
					])
				})
			}

			// ── Feuille Totaux ───────────────────────────────────────────────
			const totalsMap = {}
			for (const r of active) {
				if (!r.cart) continue
				const serviceName = this._getServiceName(r)
				for (const item of r.cart) {
					const key = serviceName + '||' + this._getArticleName(item)
					if (!totalsMap[key])
						totalsMap[key] = { service: serviceName, article: this._getArticleName(item), qty: 0, total: 0 }
					totalsMap[key].qty += Number(item.quantity) || 0
					totalsMap[key].total += (Number(item.price) || 0) * (Number(item.quantity) || 0)
				}
			}
			// Entête contextuelle : service + période
			const { serviceFilter, range_mode, range_start_day, range_start_month, range_start_year, range_end_day, range_end_month, range_end_year } = this.state
			const serviceLabel = serviceFilter
				? (this._getVenteServices().find(s => String(s._id) === String(serviceFilter)) || {}).name || 'Inconnu'
				: 'Tous les services'
			const periodLabel = range_mode
				? `${range_start_day}/${range_start_month}/${range_start_year} → ${range_end_day}/${range_end_month}/${range_end_year}`
				: this._formatDate(this.state.date)
			const totalsRows = [
				['Service :', serviceLabel],
				['Période :', periodLabel],
				[],
				['Service', 'Article', 'Quantité totale', 'Chiffre d\'affaires (€)'],
			]
			Object.values(totalsMap)
				.sort((a, b) => a.service.localeCompare(b.service) || a.article.localeCompare(b.article))
				.forEach(({ service, article, qty, total }) => totalsRows.push([service, article, qty, total]))

			// ── Génération du fichier ────────────────────────────────────────
			const wb = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(totalsRows), 'Totaux')
			XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(detailRows), 'Détail')
			const ds = new Date(this.state.date * 1000)
			const suffix = ds.getFullYear() + '-' + String(ds.getMonth() + 1).padStart(2, '0') + '-' + String(ds.getDate()).padStart(2, '0')
			XLSX.writeFile(wb, 'commandes_' + suffix + '.xlsx')
		})
	}

	// ─── Impression ticket ───────────────────────────────────────────────────────

	_printTicket = (r) => {
		const serviceName = this._getServiceName(r)
		const total = this._getCartTotal(r)
		const isCancelled = !!r.cancelled && !this.state.uncancelledIds.has(String(r._id))
		const benefit = this._resolveBenefit(r)
		const lang = this.props.lang_default || 'fr'
		const clientNum = this._getClientNumber(r)
		const clientName = this._getClientName(r)

		const W = 80
		const MIN_H = 105
		const margin = 6
		const usable = W - margin * 2
		const lineH = 5.5
		const smallH = 4.5

		const renderContent = (d) => {
			let y = margin

			const addText = (text, opts = {}) => {
				const { size = 9, bold = false, align = 'left', color = [0, 0, 0] } = opts
				d.setFontSize(size)
				d.setFont('helvetica', bold ? 'bold' : 'normal')
				d.setTextColor(...color)
				const x = align === 'center' ? W / 2 : align === 'right' ? W - margin : margin
				d.text(String(text), x, y, { align })
				y += (size >= 10 ? lineH : smallH)
			}
			const addDivider = () => {
				y += 1
				d.setDrawColor(0, 0, 0)
				d.setLineWidth(0.2)
				d.setLineDash([1.5, 1.5])
				d.line(margin, y, W - margin, y)
				d.setLineDash([])
				y += 4
			}
			const addLabel = (text) => {
				d.setFontSize(7)
				d.setFont('helvetica', 'bold')
				d.setTextColor(0, 0, 0)
				d.text(text.toUpperCase(), margin, y)
				y += 4.5
			}
			const addRow = (left, right) => {
				d.setFontSize(8.5)
				d.setFont('helvetica', 'normal')
				d.setTextColor(0, 0, 0)
				const rightW = d.getTextWidth(String(right))
				const leftLines = d.splitTextToSize(String(left), usable - rightW - 2)
				d.text(leftLines, margin, y)
				d.text(String(right), W - margin, y, { align: 'right' })
				y += leftLines.length * smallH
			}

			addText(serviceName, { size: 11, bold: true, align: 'center' })
			if (isCancelled)
			{
				y += 1
				d.setFontSize(9)
				d.setFont('helvetica', 'bold')
				d.setTextColor(0, 0, 0)
				d.setDrawColor(0, 0, 0)
				d.setLineWidth(0.3)
				d.rect(margin, y, usable, 6)
				d.text('COMMANDE ANNULÉE', W / 2, y + 4, { align: 'center' })
				y += 8
			}
			addDivider()
			addLabel('Date & retrait')
			addText(this._formatDate(r.start), { size: 8.5 })
			addText(this._formatTime(r.start) + (r.end ? ` - ${this._formatTime(r.end)}` : ''), { size: 9, bold: true })
			y += 1
			addDivider()
			addLabel('Panier')
			for (const item of (r.cart || []))
			{
				const name = this._getArticleName(item)
				const qty = Number(item.quantity) || 0
				const price = (Number(item.price) || 0) * qty
				addRow(`${qty}× ${name}`, this._formatEur(price))
			}
			y += 2
			d.setDrawColor(0, 0, 0)
			d.setLineWidth(0.3)
			d.setLineDash([])
			d.line(margin, y, W - margin, y)
			y += 5
			d.setFontSize(10)
			d.setFont('helvetica', 'bold')
			d.setTextColor(0, 0, 0)
			d.text('Total', margin, y)
			d.text(this._formatEur(total), W - margin, y, { align: 'right' })
			y += lineH + 1
			addDivider()
			addLabel('Participant')
			addText(clientName, { size: 9, bold: true })
			if (clientNum)
				addText(`N° ${clientNum}`, { size: 8.5 })
			if (r.phone)
				addText(`Tél : ${r.phone}`, { size: 8.5 })
			if (r.pitch)
				addText(`Emplacement : ${r.pitch}`, { size: 8.5 })
			if (r.age > 0)
				addText(`${r.age} ans`, { size: 8.5 })
			if (benefit && benefit.questions && benefit.questions.length > 0 && r.answers && r.answers.length > 0)
			{
				const answerPairs = benefit.questions.map((q, idx) => {
					if (!r.answers[idx]) return null
					const t = (q.translations || []).find(t => t.lang === lang) || (q.translations || [])[0]
					return { q: t ? t.title : ('Q' + (idx + 1)), a: r.answers[idx] }
				}).filter(Boolean)
				if (answerPairs.length > 0)
				{
					addDivider()
					addLabel('Réponses')
					for (const { q, a } of answerPairs)
						addRow(q, a)
				}
			}
			if (r.comment)
			{
				addDivider()
				addLabel('Commentaire')
				d.setFontSize(8.5)
				d.setFont('helvetica', 'normal')
				d.setTextColor(0, 0, 0)
				const lines = d.splitTextToSize(r.comment, usable)
				d.text(lines, margin, y)
				y += lines.length * smallH
			}

			return y
		}

		const measureDoc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [W, 500] })
		const contentY = renderContent(measureDoc)
		const baseH = Math.max(MIN_H, contentY + 8)
		const H = baseH + 50
		const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [W, H] })
		renderContent(doc)
		doc.setFontSize(6.5)
		doc.setFont('helvetica', 'normal')
		doc.setTextColor(0, 0, 0)
		doc.text('Commande réalisée via Pocket Camp', W / 2, baseH - 2, { align: 'center' })

		this._printPdf(doc)
	}

	// Déclenche l'impression du navigateur sur le PDF (sans ouvrir d'onglet)
	_printPdf = (doc) => {
		doc.autoPrint()
		const blobUrl = doc.output('bloburl')
		const iframe = document.createElement('iframe')
		iframe.setAttribute('aria-hidden', 'true')
		iframe.style.position = 'fixed'
		iframe.style.right = '0'
		iframe.style.bottom = '0'
		iframe.style.width = '0'
		iframe.style.height = '0'
		iframe.style.border = '0'
		iframe.src = blobUrl
		document.body.appendChild(iframe)
		setTimeout(() => {
			URL.revokeObjectURL(blobUrl)
			if (iframe.parentNode)
				iframe.parentNode.removeChild(iframe)
		}, 60000)
	}

	// ─── Renders ─────────────────────────────────────────────────────────────────

	// ─── Modal ajout commande ────────────────────────────────────────────────────

	closeAddModal = () => {
		this.setState({
			addModal: false, addStep: 1, addService: null, addBenefit: null,
			addDay: null, addSlot: null, addWeekOffset: 0, addCart: [], addProducts: [],
			addForm: { client_number: '', firstname: '', lastname: '', phone: '', pitch: '', comment: '', answers: [] },
			addClient: null, addError: null, addSuccess: null, addLoading: false,
		})
	}

	_getAddWeekDays = () => {
		const { addWeekOffset } = this.state
		const today = new Date()
		today.setHours(0, 0, 0, 0)
		const dow = today.getDay()
		const diffToMonday = (dow === 0) ? -6 : 1 - dow
		const monday = new Date(today)
		monday.setDate(today.getDate() + diffToMonday + addWeekOffset * 7)
		const days = []
		for (let i = 0; i < 7; i++) {
			const d = new Date(monday)
			d.setDate(monday.getDate() + i)
			days.push(Math.round(d.getTime() / 1000))
		}
		return days
	}

	_generateSlotsForModal = (benefit, dayTs) => {
		if (!benefit || !dayTs) return []
		const date = new Date(dayTs * 1000)
		const year = date.getFullYear()
		const weekday = date.getDay()
		const DAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

		let inSeason = false
		for (const od of (benefit.open_dates || [])) {
			const start = Math.round(new Date(year, od.start_month - 1, od.start_day).getTime() / 1000)
			const end = Math.round(new Date(year, od.end_month - 1, od.end_day).getTime() / 1000)
			if (dayTs >= start && dayTs <= end) { inSeason = true; break }
		}
		if (!inSeason) return []

		const applicable = (benefit.open_hours || []).filter(oh => oh[DAY_KEYS[weekday]])
		if (applicable.length === 0) return []

		const ranges = applicable.map(oh => ({ start: oh.start_hour * 60 + oh.start_minute, end: oh.end_hour * 60 + oh.end_minute })).sort((a, b) => a.start - b.start)
		const merged = [{ ...ranges[0] }]
		for (let i = 1; i < ranges.length; i++) {
			const last = merged[merged.length - 1]
			if (ranges[i].start <= last.end) { last.end = Math.max(last.end, ranges[i].end) }
			else { merged.push({ ...ranges[i] }) }
		}

		const duration = benefit.duration_hour * 60 + benefit.duration_minute
		const interval = benefit.interval_hour * 60 + benefit.interval_minute
		const slots = []
		for (const range of merged) {
			if (duration === 0) {
				// Toute la plage = 1 seul créneau (ex: boutique 7h-10h)
				slots.push({ start: range.start, end: range.end, booked: 0 })
			} else {
				let startSlot = range.start
				let endSlot = startSlot + duration
				while (endSlot + interval <= range.end) {
					slots.push({ start: startSlot, end: endSlot, booked: 0 })
					startSlot = endSlot + interval
					endSlot = startSlot + duration
				}
			}
		}
		return slots
	}

	_findNextAvailableDay = (benefit, fromDayTs) => {
		for (let i = 1; i <= 365; i++) {
			const d = new Date(fromDayTs * 1000); d.setDate(d.getDate() + i); d.setHours(0, 0, 0, 0)
			const t = Math.round(d.getTime() / 1000)
			if (this._generateSlotsForModal(benefit, t).length > 0) return t
		}
		return null
	}

	_formatDayFull = (ts) => {
		const d = new Date(ts * 1000)
		const days = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.']
		const months = ['jan.', 'fév.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sep.', 'oct.', 'nov.', 'déc.']
		return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]
	}

	selectAddService = (service) => {
		const today = new Date(); today.setHours(0, 0, 0, 0)
		const todayTs = Math.round(today.getTime() / 1000)
		// Pré-sélectionner la date du tile actif si elle est ≥ aujourd'hui, sinon aujourd'hui
		const tileTs = this.state.date
		const preselectedDay = (tileTs && tileTs >= todayTs) ? tileTs : todayTs
		// Calculer l'offset de semaine correspondant (même logique que _goToNextAvailableDay)
		const dow = today.getDay()
		const diffToMonday = (dow === 0) ? -6 : 1 - dow
		const thisMonday = new Date(today); thisMonday.setDate(today.getDate() + diffToMonday)
		const thisMondayTs = Math.round(thisMonday.getTime() / 1000)
		const diffDays = Math.round((preselectedDay - thisMondayTs) / 86400)
		const preselectedWeekOffset = Math.floor(diffDays / 7)
		const promises = [
			this.props.fetchServiceBenefitsByService ? this.props.fetchServiceBenefitsByService(String(service._id)) : Promise.resolve([]),
			this.props.fetchServiceProductsByService ? this.props.fetchServiceProductsByService(String(service._id)) : Promise.resolve([]),
		]
		Promise.all(promises).then(([benefits, products]) => {
			const benefit = (benefits || []).find(b => b.open_hours && b.open_hours.length > 0) || null
			this.setState({ addService: service, addBenefit: benefit, addProducts: products || [], addDay: preselectedDay, addWeekOffset: preselectedWeekOffset, addStep: 2 })
		}).catch(() => {
			this.setState({ addService: service, addBenefit: null, addProducts: [], addDay: preselectedDay, addWeekOffset: preselectedWeekOffset, addStep: 2 })
		})
	}

	_goToNextAvailableDay = (dayTs) => {
		const today = new Date(); today.setHours(0, 0, 0, 0)
		const dow = today.getDay()
		const diffToMonday = (dow === 0) ? -6 : 1 - dow
		const thisMonday = new Date(today); thisMonday.setDate(today.getDate() + diffToMonday)
		const thisMondayTs = Math.round(thisMonday.getTime() / 1000)
		const diffDays = Math.round((dayTs - thisMondayTs) / 86400)
		const weekOffset = Math.floor(diffDays / 7)
		this.setState({ addDay: dayTs, addWeekOffset: weekOffset, addSlot: null })
	}

	selectAddDay = (dayTs) => {
		this.setState({ addDay: dayTs, addSlot: null })
	}

	selectAddSlot = (slot) => {
		this.setState({ addSlot: slot, addStep: 3 })
	}

	_cartQty = (articleId) => {
		const item = this.state.addCart.find(i => String(i._id) === String(articleId))
		return item ? item.quantity : 0
	}

	_cartUpdate = (article, delta) => {
		const cart = [...this.state.addCart]
		const idx = cart.findIndex(i => String(i._id) === String(article._id))
		if (idx === -1) {
			if (delta > 0)
				cart.push({ _id: article._id, quantity: 1, price: article.price, stock: article.stock, translations: article.translations })
		} else {
			const newQty = cart[idx].quantity + delta
			if (newQty <= 0)
				cart.splice(idx, 1)
			else
				cart[idx] = { ...cart[idx], quantity: newQty }
		}
		this.setState({ addCart: cart })
	}

	_cartTotal = () => {
		return this.state.addCart.reduce((sum, i) => sum + (Number(i.price) || 0) * (Number(i.quantity) || 0), 0)
	}

	_lookupAddClient = (value) => {
		if (!value) { this.setState({ addClient: null }); return }
		const clients = this.state.clients || []
		let client = null
		for (let i = 0; i < clients.length; i++) {
			if (String(clients[i].client_number) === String(value)) { client = clients[i]; break }
		}
		if (client) {
			this.setState(prevState => {
				const addForm = { ...prevState.addForm }
				const civ = client.civility === 'femme' ? 'Mme. ' : client.civility === 'homme' ? 'Mr. ' : ''
				if (!addForm.firstname && !addForm.lastname) {
					addForm.firstname = (civ + (client.firstname || '')).trim()
					addForm.lastname = client.lastname || ''
				}
				if (!addForm.phone) addForm.phone = client.phone1 || client.phone2 || client.phone3 || ''
				return { addClient: client, addForm }
			})
		} else {
			this.setState({ addClient: null })
		}
	}

	submitAddCommande = (e) => {
		e.preventDefault()
		const { addService, addBenefit, addDay, addSlot, addCart, addForm } = this.state
		if (addCart.length === 0)
		{
			this.setState({ addError: 'Ajoutez au moins un article.' })
			return ;
		}
		const now = Math.round(Date.now() / 1000)
		const start = (addDay && addSlot) ? addDay + addSlot.start * 60 : now
		const end = (addDay && addSlot) ? addDay + addSlot.end * 60 : now + 3600
		this.setState({ addLoading: true, addError: null })
		this.props.submitServiceCart({
			service: String(addService._id),
			service_benefit: addBenefit ? String(addBenefit._id) : null,
			cart: addCart,
			start,
			end,
			user: null,
			client_number: addForm.client_number || '',
			firstname: addForm.firstname || '',
			lastname: addForm.lastname || '',
			identity: ((addForm.firstname || '') + ' ' + (addForm.lastname || '')).trim(),
			pitch: addForm.pitch || '',
			comment: addForm.comment || '',
			age: '',
			phone: addForm.phone || '',
			answers: addForm.answers,
		})
		.then(ret => {
			if (!ret || ret.error)
			{
				let msg = 'Erreur lors de la création de la commande. Veuillez réessayer.'
				if (ret && ret.error === 'stock') msg = 'Stock insuffisant : un ou plusieurs articles ne sont plus disponibles en quantité demandée.'
				this.setState({ addLoading: false, addError: msg })
				return ;
			}
			this.closeAddModal()
			this._loadReservations()
		})
		.catch(() => this.setState({ addLoading: false, addError: 'Erreur réseau. Vérifiez votre connexion.' }))
	}

	_renderTitleRow = () => {
		const { date, range_mode, nav_center_day, nav_center_month, nav_center_year,
			range_start_day, range_start_month, range_start_year,
			range_end_day, range_end_month, range_end_year, available_years, tile_counts } = this.state

		const _toggleRange = () => this.setState(prev => {
			if (prev.range_mode)
			{
				const d = new Date(parseInt(prev.range_start_year), parseInt(prev.range_start_month) - 1, parseInt(prev.range_start_day))
				d.setHours(0, 0, 0, 0)
				return {
					range_mode: false,
					date: Math.floor(d.getTime() / 1000),
					nav_center_day: prev.range_start_day,
					nav_center_month: prev.range_start_month,
					nav_center_year: prev.range_start_year,
					panel: null,
					slotFilter: null
				}
			}
			const d = new Date(prev.date * 1000)
			const pad = n => String(n).padStart(2, '0')
			const day = pad(d.getDate())
			const month = pad(d.getMonth() + 1)
			const year = String(d.getFullYear())
			return {
				range_mode: true,
				range_start_day: day, range_start_month: month, range_start_year: year,
				range_end_day: day, range_end_month: month, range_end_year: year
			}
		}, () => this._loadReservations())

		const day_abbr = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
		const selectedDate = new Date(date * 1000)
		const selected_key = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`
		const tiles = []
		for (let i = -2; i <= 2; i++)
		{
			const d = new Date(parseInt(nav_center_year), parseInt(nav_center_month) - 1, parseInt(nav_center_day))
			d.setDate(d.getDate() + i)
			const d_day = String(d.getDate()).padStart(2, '0')
			const d_month = String(d.getMonth() + 1).padStart(2, '0')
			const d_year = String(d.getFullYear())
			const d_key = `${d_year}-${d_month}-${d_day}`
			const is_selected = d_key === selected_key
			tiles.push(
				<button key={i}
					onClick={() => {
						const ts = Math.floor(new Date(parseInt(d_year), parseInt(d_month) - 1, parseInt(d_day)).getTime() / 1000)
						this.setState({ date: ts, panel: null, slotFilter: null }, this._loadReservations)
					}}
					className={`flex-shrink-0 flex flex-col items-center justify-center min-w-[75px] h-16 py-10 px-6 rounded-xl border transition-all ${
						is_selected ? 'border-indigo-300 shadow-md scale-105 z-10' : 'border-transparent hover:border-gray-200'
					}`}
					style={{ backgroundColor: '#ffffff', backgroundImage: 'none' }}
				>
					<span className={`text-xs font-bold tracking-widest mb-0.5 ${is_selected ? 'text-indigo-500' : 'text-gray-400'}`}>
						{day_abbr[d.getDay()]}.
					</span>
					<span className={`text-lg font-black leading-none ${is_selected ? 'text-indigo-500' : 'text-gray-900'}`}>
						{d_day}
					</span>
					{tile_counts[d_key] > 0 && (
						<span className={`text-xs font-bold mt-0.5 ${is_selected ? 'text-indigo-400' : 'text-gray-300'}`}>
							{tile_counts[d_key]}
						</span>
					)}
				</button>
			)
		}

		const days_arr = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0'))
		const months_arr = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'))
		const { day: today_day, month: today_month, year: today_year } = this._getTodayParts()
		const nav_key = `${nav_center_year}-${nav_center_month}-${nav_center_day}`
		const today_key = `${today_year}-${today_month}-${today_day}`
		const is_centered_today = nav_key === today_key

		return (
			<div className="flex items-center justify-between px-6 pb-2">
				<div className="flex-1">
					<h2
						className="text-3xl font-bold text-gray-900"
						style={{ fontFamily: "'Fraunces', Georgia, serif" }}
					>
						Boutique & commandes
					</h2>

					{!range_mode ? (
						<div className="flex items-center gap-2 mt-3">
							<button
								onClick={() => {
									const { day, month, year } = this._getTodayParts()
									const now = new Date()
									now.setHours(0, 0, 0, 0)
									this.setState({ date: Math.floor(now.getTime() / 1000), nav_center_day: day, nav_center_month: month, nav_center_year: year, panel: null, slotFilter: null }, this._loadReservations)
								}}
								className="text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-lg border border-indigo-200 text-indigo-600 hover:bg-indigo-50 transition-colors shrink-0"
								style={{ backgroundImage: 'none', backgroundColor: is_centered_today ? '#eef2ff' : '#ffffff' }}
							>
								Aujourd'hui
							</button>
							<button
								onClick={() => this._shiftWeek(-1)}
								className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors shrink-0"
								style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
							>
								<svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
								</svg>
							</button>
							<div className="flex items-center gap-1">
								{tiles}
							</div>
							<button
								onClick={() => this._shiftWeek(1)}
								className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors shrink-0"
								style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
							>
								<svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
								</svg>
							</button>
						</div>
					) : (
						<div className="flex items-center gap-2 mt-3 flex-wrap">
							<button
								onClick={() => this._shiftRange(-1)}
								className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors shrink-0"
								style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
							>
								<svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
								</svg>
							</button>
							<div className="flex items-center gap-1 text-sm font-medium text-gray-600">
								<span>Du</span>
								<select
									value={range_start_day}
									onChange={e => this.setState({ range_start_day: e.target.value })}
									className="border border-gray-200 rounded-lg px-2 py-1 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400"
								>
									{days_arr.map(d => <option key={d} value={d}>{d}</option>)}
								</select>
								<select
									value={range_start_month}
									onChange={e => this.setState({ range_start_month: e.target.value })}
									className="border border-gray-200 rounded-lg px-2 py-1 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400"
								>
									{months_arr.map(m => <option key={m} value={m}>{m}</option>)}
								</select>
								<select
									value={range_start_year}
									onChange={e => this.setState({ range_start_year: e.target.value })}
									className="border border-gray-200 rounded-lg px-2 py-1 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400"
								>
									{available_years.map(y => <option key={y} value={y}>{y}</option>)}
								</select>
							</div>
							<div className="flex items-center gap-1 text-sm font-medium text-gray-600">
								<span>Au</span>
								<select
									value={range_end_day}
									onChange={e => this.setState({ range_end_day: e.target.value })}
									className="border border-gray-200 rounded-lg px-2 py-1 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400"
								>
									{days_arr.map(d => <option key={d} value={d}>{d}</option>)}
								</select>
								<select
									value={range_end_month}
									onChange={e => this.setState({ range_end_month: e.target.value })}
									className="border border-gray-200 rounded-lg px-2 py-1 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400"
								>
									{months_arr.map(m => <option key={m} value={m}>{m}</option>)}
								</select>
								<select
									value={range_end_year}
									onChange={e => this.setState({ range_end_year: e.target.value })}
									className="border border-gray-200 rounded-lg px-2 py-1 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400"
								>
									{available_years.map(y => <option key={y} value={y}>{y}</option>)}
								</select>
							</div>
							<button
								onClick={() => this._shiftRange(1)}
								className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors shrink-0"
								style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
							>
								<svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
								</svg>
							</button>
							<button
								onClick={_toggleRange}
								className="text-xs font-semibold text-gray-500 hover:text-indigo-600 border border-gray-200 px-3 py-1.5 rounded-lg hover:border-indigo-300 transition-colors shrink-0"
								style={{ backgroundImage: 'none', backgroundColor: '#ffffff' }}
							>
								Revenir au jour
							</button>
							<button
								onClick={() => this._loadReservations()}
								className="text-xs font-bold text-white px-4 py-1.5 rounded-lg transition-colors shrink-0"
								style={{ backgroundImage: 'none', backgroundColor: '#4f46e5' }}
							>
								Appliquer
							</button>
						</div>
					)}
				</div>
				<div className="flex items-center gap-3 ml-6">
					<button
						onClick={() => this.props.history.push('/services/commandes/calculatrice')}
						title="Calculatrice d'espèces"
						className="flex items-center justify-center bg-white border border-gray-200 p-2 rounded-xl shadow-sm hover:bg-gray-50 transition-colors"
						style={{ backgroundImage: 'none' }}
					>
						<svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
						</svg>
					</button>
					<button
						onClick={this._downloadXlsx}
						className="flex items-center gap-2 bg-white border border-gray-200 px-4 py-2 rounded-xl text-sm font-semibold shadow-sm hover:bg-gray-50 transition-colors"
						style={{ backgroundImage: 'none' }}
					>
						<svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
						</svg>
						Exporter Excel
					</button>
					<div
						role="button" tabIndex={0}
						onClick={() => this.setState({ addModal: true })}
						onKeyDown={e => e.key === 'Enter' && this.setState({ addModal: true })}
						className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-xl text-sm font-semibold transition-colors cursor-pointer select-none"
					>
						<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
						</svg>
						Nouvelle commande
					</div>
				</div>
			</div>
		)
	}

	_renderRecap = () => {
		const active = this._getFilteredReservations()
		const articles = this._aggregateByArticle(active)
		const total = this._getDayTotal(active)
		const servedCount = active.filter(r => r.served).length
		const remainingCount = active.length - servedCount
		const allDone = remainingCount === 0 && active.length > 0

		return (
			<div className="grid grid-cols-3 gap-6">
				<div className="bg-white rounded-3xl border border-gray-200 shadow-sm p-6">
					<p className="text-xs font-semibold text-gray-500 uppercase tracking-tight mb-4">Production</p>
					{articles.length === 0 ? (
						<p className="text-sm text-gray-300">Aucune commande.</p>
					) : (
						<div className="flex flex-col gap-2 overflow-y-auto" style={{ maxHeight: '10rem' }}>
							{articles.map(a => (
								<div key={a.id} className="flex items-center justify-between py-1 border-b border-gray-50 last:border-0">
									<span className="text-sm font-medium text-gray-700 truncate">{a.name}</span>
									<span className="bg-indigo-50 text-indigo-700 text-xs font-bold px-2 py-0.5 rounded-md shrink-0 ml-2">{a.quantity}×</span>
								</div>
							))}
						</div>
					)}
				</div>
				<div className="bg-white rounded-3xl border border-gray-200 shadow-sm p-6">
					<div className="flex items-start gap-4 mb-4">
						<div className="flex-1 text-left">
							<p className="text-xs font-semibold text-gray-500 uppercase tracking-tight mb-4">Commandes</p>
							<span className="text-5xl font-black text-gray-900">{active.length}</span>
						</div>
						<div className="flex-1 text-left">
							<p className="text-xs font-semibold text-gray-500 uppercase tracking-tight mb-4">DASHBOARD</p>
							<span className="text-5xl font-black text-gray-900">{active.filter(r => r.from === 'dashboard').length}</span>
						</div>
						<div className="flex-1 text-left">
							<p className="text-xs font-semibold text-gray-500 uppercase tracking-tight mb-4">APP</p>
							<span className="text-5xl font-black text-gray-900">{active.filter(r => r.from === 'webapp').length}</span>
						</div>
					</div>
					<p className="text-sm text-gray-400 mt-1 italic">Total généré</p>
					<p className="mt-4 text-xl font-bold text-emerald-600">{this._formatEur(total)}</p>
				</div>
				<div className="bg-white rounded-3xl border border-gray-200 shadow-sm p-6">
					<p className="text-xs font-semibold text-gray-500 uppercase tracking-tight mb-4">
						{allDone ? 'Tout servi' : 'À servir'}
					</p>
					<span className="text-5xl font-black" style={{ color: allDone ? '#16a34a' : '#f59e0b' }}>{remainingCount}</span>
					<p className="text-sm text-gray-400 mt-1 italic">Restantes à préparer</p>
					{servedCount > 0 && (
						<div className="mt-4 flex items-center gap-2 text-gray-500 text-sm font-medium">
							<svg className="w-4 h-4 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
							</svg>
							<span>{servedCount} servie{servedCount > 1 ? 's' : ''}</span>
						</div>
					)}
				</div>
			</div>
		)
	}

	_renderFilters = () => {
		const { serviceFilter, slotFilter, reservations } = this.state
		const services = this._getVenteServices()
		const allSlots = this._groupBySlot(this._getFilteredReservations())

		const countByService = {}
		let totalCount = 0
		for (let i = 0; i < (reservations || []).length; i++) {
			const r = reservations[i]
			if (r.cancelled) continue
			const sid = (r.service && r.service._id) ? String(r.service._id) : String(r.service)
			countByService[sid] = (countByService[sid] || 0) + 1
			totalCount++
		}

		const hasServiceFilter = services.length > 1
		const hasSlotFilter = allSlots.length > 1
		if (!hasServiceFilter && !hasSlotFilter) return null

		return (
			<div className="space-y-4">
				{hasServiceFilter && (
					<div className="flex items-center gap-2 flex-wrap">
						<svg className="w-4 h-4 text-gray-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z" />
						</svg>
						<FilterChip
							label="Tous"
							count={totalCount}
							active={serviceFilter === null}
							onClick={() => this.setState({ serviceFilter: null, slotFilter: null })}
						/>
						{services.map(s => (
							<FilterChip
								key={s._id}
								label={s.name}
								count={countByService[String(s._id)] || 0}
								active={serviceFilter === String(s._id)}
								onClick={() => this.setState({ serviceFilter: String(s._id), slotFilter: null })}
							/>
						))}
					</div>
				)}
				{hasSlotFilter && (
					<div className="flex items-center gap-2 flex-wrap">
						<svg className="w-4 h-4 text-gray-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
						</svg>
						<div
							role="button"
							tabIndex={0}
							onClick={() => this.setState({ slotFilter: null })}
							className={`cursor-pointer px-4 py-1.5 rounded-full text-sm font-medium transition-colors border ${slotFilter === null ? 'border-yellow-200' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'}`}
							style={slotFilter === null ? { backgroundColor: '#fef3c7', color: '#b45309' } : {}}
						>
							Tous
						</div>
						{allSlots.map(slot => {
							const remaining = this._getSlotRemaining(slot)
							const slotTotal = slot.reservations.length
							const allDone = remaining === 0
							const isActive = slotFilter === slot.time
							return (
								<div
									key={slot.time}
									role="button"
									tabIndex={0}
									onClick={() => this.setState({ slotFilter: isActive ? null : slot.time })}
									className={`cursor-pointer flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-medium transition-colors border ${
										allDone
											? 'bg-green-50 text-green-700 border-green-200'
											: isActive
												? 'border-yellow-200'
												: 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'
									}`}
									style={isActive && !allDone ? { backgroundColor: '#fef3c7', color: '#b45309' } : {}}
								>
									{allDone && (
										<svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
											<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
										</svg>
									)}
									{this._formatTime(slot.time)}
									{!allDone && (
										<span className={`text-xs font-semibold ${isActive ? 'text-yellow-500' : 'text-yellow-400'}`}>
											{remaining}/{slotTotal}
										</span>
									)}
								</div>
							)
						})}
					</div>
				)}
			</div>
		)
	}

	_renderCommandeCard = (r) => {
		const { uncancelledIds, cancellingId } = this.state
		const isCancelled = !!r.cancelled && !uncancelledIds.has(String(r._id))
		const isChecked = !isCancelled && !!r.served
		const isPaid = !isCancelled && !!r.paid
		const isStripePaid = isPaid && r.paid_by === 'stripe'
		const isCancelling = cancellingId === String(r._id)
		const cart = r.cart || []
		const visibleItems = cart.slice(0, 3)
		const extraCount = cart.length - visibleItems.length

		return (
			<motion.div
				key={r._id}
				className={`flex flex-col rounded-3xl border overflow-hidden transition-all duration-300 ${
					isChecked
						? 'bg-white border-green-200'
						: 'border-gray-200 bg-white hover:shadow-md'
				}`}
				animate={isCancelling
					? { scale: 0.97, opacity: 0.4, backgroundColor: 'rgba(239,68,68,0.07)' }
					: { scale: 1, opacity: 1, backgroundColor: '#ffffff' }
				}
				transition={{ duration: 0.4, ease: 'easeOut' }}
			>
				<button
					onClick={() => this.setState({ panel: { type: 'reservation', data: r } })}
					className="flex-1 text-left p-5 hover:bg-gray-50 transition-colors group focus:outline-none focus:bg-white active:bg-transparent"
				>
					<div className="flex items-start justify-between mb-2">
						<span className={`text-base font-bold uppercase tracking-tight truncate ${isChecked ? 'text-green-700' : 'text-gray-900'}`}>
							{this._getClientName(r)}
						</span>
						<div className="flex items-center gap-1.5 shrink-0 ml-2">
							{r.from === 'dashboard' ? (
								<span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-gray-100 text-gray-500">dashboard</span>
							) : (
								<span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-sky-100 text-sky-600">app</span>
							)}
							{this._getClientNumber(r) && (
								<span className="text-xs font-mono font-bold px-2 py-0.5 rounded border bg-gray-50 text-gray-400 border-gray-200">{this._getClientNumber(r)}</span>
							)}
						</div>
					</div>
					{this.state.serviceFilter === null && (
						<p className="text-sm text-indigo-400 font-semibold mb-2 capitalize">{this._getServiceName(r)}</p>
					)}
					<div className="flex flex-col gap-1.5 mb-4" style={{ minHeight: '5rem' }}>
						{visibleItems.map((item, i) => (
							<div key={i} className="flex items-center gap-2">
								<span className={`text-sm font-black shrink-0 ${isChecked ? 'text-green-600' : 'text-indigo-600'}`}>
									{item.quantity}×
								</span>
								<span className={`text-sm font-medium truncate ${isChecked ? 'text-gray-400' : 'text-gray-600'}`}>
									{this._getArticleName(item)}
								</span>
							</div>
						))}
						{extraCount > 0 && (
							<p className="text-xs text-gray-400 font-medium">+ {extraCount} autre{extraCount > 1 ? 's' : ''}</p>
						)}
					</div>
					<div className="flex items-center justify-between pt-3 border-t border-gray-100">
						<span className={`text-lg font-black ${isChecked ? 'text-green-700' : 'text-gray-900'}`}>
							{this._formatEur(this._getCartTotal(r))}
						</span>
						{isChecked ? (
							<span className="text-xs font-bold text-green-600 flex items-center gap-1">
								<svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
								</svg>
								Servi
							</span>
						) : (
							<span className="text-xs font-bold text-yellow-500 flex items-center gap-1 bg-yellow-50 px-2 py-0.5 rounded-full">
								<svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
								</svg>
								{this._formatTime(r.start)}
							</span>
						)}
					</div>
				</button>
				{isCancelled ? (
					<div className="w-full py-3 text-sm font-semibold flex items-center justify-center gap-2 bg-white text-red-400 border-t border-red-100">
						<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
						</svg>
						Annulée
					</div>
				) : (
					<div className="flex w-full border-t border-gray-100">
						<button
							onClick={(e) => this._toggleServed(r._id, e)}
							className={`flex-1 py-4 text-sm font-bold transition-all flex items-center justify-center gap-2 focus:outline-none ${
								isChecked
									? 'bg-green-50 text-green-700 hover:bg-green-100 focus:bg-green-50'
									: 'bg-white text-gray-500 hover:bg-indigo-600 hover:text-white focus:bg-white'
							}`}
						>
							{isChecked ? (
								<>
									<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
									</svg>
									Servi
								</>
							) : (
								<>
									<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
									</svg>
									À servir
								</>
							)}
						</button>
						{isStripePaid ? (
							<div className="flex-1 py-4 text-sm font-bold flex items-center justify-center gap-2 border-l border-gray-100 bg-indigo-50 text-indigo-600 cursor-default" title="Payé par carte bancaire dans l'application — statut non modifiable">
								<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h2m4 0h4M5 6h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2z" />
								</svg>
								Payé Stripe
							</div>
						) : (
						<button
							onClick={(e) => this._togglePaid(r._id, e)}
							className={`flex-1 py-4 text-sm font-bold transition-all flex items-center justify-center gap-2 focus:outline-none border-l border-gray-100 ${
								isPaid
									? 'bg-green-50 text-green-700 hover:bg-green-100 focus:bg-green-50'
									: 'bg-white text-gray-500 hover:bg-emerald-600 hover:text-white focus:bg-white'
							}`}
						>
							{isPaid ? (
								<>
									<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
									</svg>
									Payé
								</>
							) : (
								<>
									<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z" />
									</svg>
									À payer
								</>
							)}
						</button>
						)}
					</div>
				)}
			</motion.div>
		)
	}

	_renderCreneauSection = (slot) => {
		const { slotFilter } = this.state
		if (slotFilter !== null && slot.time !== slotFilter) return null
		const remaining = this._getSlotRemaining(slot)
		const sorted = [
			...slot.reservations.filter(r => !r.served),
			...slot.reservations.filter(r => r.served),
		]

		return (
			<div key={slot.time}>
				<div className="flex items-center justify-between border-b border-gray-200 pb-3 mb-4">
					<h3 className="font-bold text-gray-500 uppercase tracking-widest text-xs">
						{this._formatTime(slot.time)}
					</h3>
					<span className={`text-xs font-medium ${remaining === 0 ? 'text-green-500' : 'text-gray-400'}`}>
						{remaining === 0 ? 'Tout servi ✓' : `${sorted.length} commande${sorted.length > 1 ? 's' : ''} · ${remaining} restante${remaining > 1 ? 's' : ''}`}
					</span>
				</div>
				<div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
					{sorted.map(r => this._renderCommandeCard(r))}
				</div>
			</div>
		)
	}

	_renderCreneaux = () => {
		const active = this._getFilteredReservations()
		const allSlots = this._groupBySlot(active)

		return (
			<div className="flex flex-col gap-4">
				{active.length === 0 ? (
					<div className="py-12 text-center text-gray-400 text-sm">
						Aucune commande active pour cette journée.
					</div>
				) : (
					<>
							{allSlots.map(slot => this._renderCreneauSection(slot))}
					</>
				)}
				{this._renderCancelledToggle()}
			</div>
		)
	}

	_renderCancelledToggle = () => {
		const { showCancelled } = this.state
		const cancelled = this._getCancelledReservations()
		if (cancelled.length === 0) return null

		return (
			<div className="mt-1">
				<button
					onClick={() => this.setState({ showCancelled: !showCancelled })}
					className="text-xs text-gray-400 hover:text-gray-600 flex items-center gap-1"
				>
					<svg className={`w-3.5 h-3.5 transition-transform ${showCancelled ? 'rotate-90' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
					</svg>
					{showCancelled ? 'Masquer' : 'Voir'} les annulées ({cancelled.length})
				</button>
				{showCancelled && (
					<div className="mt-2 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
						{cancelled.map(r => this._renderCommandeCard(r))}
					</div>
				)}
			</div>
		)
	}

	_renderSourceBadge = (from) => {
		if (from === 'dashboard')
			return <span className="text-base px-2 py-0.5 rounded-full bg-green-100 text-green-700 shrink-0">dashboard</span>
		return <span className="text-base px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 shrink-0">app</span>
	}

	_resolveBenefit = (r) => {
		const { service_benefits } = this.state
		const bId = (r.service_benefit && r.service_benefit._id) ? String(r.service_benefit._id) : (r.service_benefit ? String(r.service_benefit) : null)
		if (bId)
			return (service_benefits || []).find(b => String(b._id) === bId) || null
		const sId = typeof r.service === 'object' ? String(r.service._id) : String(r.service)
		return (service_benefits || []).find(b => String(b.service) === sId) || null
	}

	_renderPanel = () => {
		const { panel } = this.state
		if (!panel || panel.type !== 'reservation') return null

		const r = panel.data
		const closePanel = () => this.setState({ panel: null })
		const total = this._getCartTotal(r)
		const isCancelled = !!r.cancelled && !this.state.uncancelledIds.has(String(r._id))

		return (
			<>
				<div className="fixed inset-0 bg-black/30 z-40" onClick={closePanel} />
				<div className="fixed top-0 right-0 w-96 bg-white shadow-2xl z-50" style={{ display: 'flex', flexDirection: 'column', height: '100vh', maxHeight: '100vh' }}>
					<div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
						<p className="text-base font-semibold text-gray-900">Détails de la commande</p>
						<button onClick={closePanel} className="text-gray-400 hover:text-gray-700 text-xl leading-none">✕</button>
					</div>

					<div className="overflow-y-auto px-5 py-5 space-y-5" style={{ flex: '1 1 0', minHeight: 0 }}>
						<div>
							<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Service</p>
							<div className="border-l-4 border-indigo-500 pl-3">
								<p className="text-base font-semibold text-gray-900">{this._getServiceName(r)}</p>
								{isCancelled && <span className="inline-block mt-1 text-xs bg-gray-100 text-gray-500 font-semibold px-2 py-0.5 rounded">Commande annulée</span>}
							</div>
						</div>

						<hr className="border-gray-100" />

						<div className="flex gap-8">
							<div>
								<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-1">Date</p>
								<p className="text-base font-semibold text-gray-900">{this._formatDate(this.state.date)}</p>
							</div>
							<div>
								<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-1">Retrait</p>
								<p className="text-base font-semibold text-gray-900">{this._formatTime(r.start)}{r.end ? ` → ${this._formatTime(r.end)}` : ''}</p>
							</div>
						</div>

						<hr className="border-gray-100" />

						<div>
							<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Panier</p>
							<div className="border border-gray-200 rounded-xl overflow-hidden">
								{r.cart && r.cart.map((item, i) => (
									<div key={i} className="flex items-center justify-between px-3 py-2.5 border-b border-gray-100 last:border-0">
										<span className="text-base text-gray-800">{this._getArticleName(item)}</span>
										<div className="flex items-center gap-3">
											<span className="text-base font-semibold text-green-500">×{item.quantity}</span>
											<span className="text-base text-gray-700">{this._formatEur((Number(item.price) || 0) * (Number(item.quantity) || 0))}</span>
										</div>
									</div>
								))}
								<div className="flex items-center justify-between px-3 py-2.5 bg-gray-50">
									<span className="text-base font-semibold text-gray-900">Total</span>
									<span className="text-base font-semibold text-gray-900">{this._formatEur(total)}</span>
								</div>
							</div>
						</div>

						<hr className="border-gray-100" />

						<div>
							<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Participant</p>
							<div className="border border-gray-200 rounded-xl divide-y divide-gray-100 overflow-hidden">
								{this._getClientNumber(r) && (
									<div className="flex items-center justify-between px-3 py-2.5">
										<span className="text-base text-gray-700">Numéro client</span>
										<span className="text-base font-semibold text-gray-800">{this._getClientNumber(r)}</span>
									</div>
								)}
								{r.firstname && (
									<div className="flex items-center justify-between px-3 py-2.5">
										<span className="text-base text-gray-700">Prénom</span>
										<span className="text-base font-semibold text-gray-800">{r.firstname}</span>
									</div>
								)}
								{r.lastname && (
									<div className="flex items-center justify-between px-3 py-2.5">
										<span className="text-base text-gray-700">Nom</span>
										<span className="text-base font-semibold text-gray-800">{r.lastname}</span>
									</div>
								)}
								{!r.firstname && !r.lastname && r.identity && (
									<div className="flex items-center justify-between px-3 py-2.5">
										<span className="text-base text-gray-700">Nom et prénom</span>
										<span className="text-base font-semibold text-gray-800">{r.identity}</span>
									</div>
								)}
								{r.phone && (
									<div className="flex items-center justify-between px-3 py-2.5">
										<span className="text-base text-gray-700">Téléphone</span>
										<span className="text-base font-semibold text-gray-800">{r.phone}</span>
									</div>
								)}
								{r.pitch && (
									<div className="flex items-center justify-between px-3 py-2.5">
										<span className="text-base text-gray-700">Emplacement</span>
										<span className="text-base font-semibold text-gray-800">{r.pitch}</span>
									</div>
								)}
								{r.age > 0 && (
									<div className="flex items-center justify-between px-3 py-2.5">
										<span className="text-base text-gray-700">Âge</span>
										<span className="text-base font-semibold text-gray-800">{r.age} ans</span>
									</div>
								)}
							</div>
						</div>

						{(() => {
							const benefit = this._resolveBenefit(r)
							if (!benefit || !benefit.questions || benefit.questions.length === 0 || !r.answers || r.answers.length === 0) return null
							const lang = this.props.lang_default || 'fr'
							const rows = benefit.questions.map((q, idx) => {
								if (!r.answers[idx]) return null
								const t = (q.translations || []).find(t => t.lang === lang) || (q.translations || [])[0]
								const label = t ? t.title : ('Q' + (idx + 1))
								return (
									<div key={idx} className="flex items-center justify-between px-3 py-2.5 border-b border-gray-100 last:border-0">
										<span className="text-base text-gray-700">{label}</span>
										<span className="text-base font-semibold text-gray-800">{r.answers[idx]}</span>
									</div>
								)
							}).filter(Boolean)
							if (rows.length === 0) return null
							return (
								<>
									<hr className="border-gray-100" />
									<div>
										<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Réponses</p>
										<div className="border border-gray-200 rounded-xl overflow-hidden">{rows}</div>
									</div>
								</>
							)
						})()}

						{r.comment && (
							<>
								<hr className="border-gray-100" />
								<div>
									<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-1">Commentaire dashboard</p>
									<p className="text-base text-gray-700 font-semibold whitespace-pre-wrap">{r.comment}</p>
								</div>
							</>
						)}

						<hr className="border-gray-100" />

						<div className="space-y-1.5">
							<div className="flex items-center gap-2 flex-wrap">
								<p className="text-base text-gray-400">Commandé depuis</p>
								{this._renderSourceBadge(r.from)}
								{r.created_time && (
									<p className="text-base text-gray-400">le {this._formatDayFull(r.created_time)} à {this._formatTime(r.created_time)}</p>
								)}
							</div>
							{(r.edit_history || []).map((entry, i) => (
								<div key={i} className="flex items-center gap-2 flex-wrap">
									<p className="text-base text-gray-400">Modifié le {this._formatDayFull(entry.at)} à {this._formatTime(entry.at)}</p>
									<span className="text-xs px-2 py-0.5 rounded-full font-medium bg-violet-50 text-violet-600">par {entry.user || (entry.by === 'dashboard' ? 'Dashboard' : entry.by || 'inconnu')}</span>
								</div>
							))}
						</div>
					</div>

					<div style={{ flexShrink: 0, padding: '16px 20px', borderTop: '1px solid #e5e7eb', backgroundColor: '#ffffff' }}>
						<button
							className="w-full text-base font-medium rounded-xl py-2.5 transition-colors flex items-center justify-center gap-2 mb-2"
							style={{ backgroundImage: 'none', backgroundColor: '#f8fafc', color: '#374151', border: '1px solid #e5e7eb' }}
							onClick={() => this._printTicket(r)}
						>
							<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
							</svg>
							Imprimer ticket
						</button>
						{!isCancelled && (
							<button
								className="w-full text-base font-medium rounded-xl py-2.5 transition-colors mb-2"
								style={{ backgroundImage: 'none', backgroundColor: '#eef2ff', color: '#4f46e5', border: '1px solid #c7d2fe' }}
								onClick={() => { closePanel(); this.openEditModal(r) }}
							>
								Modifier la commande
							</button>
						)}
						{isCancelled ? (
							<button
								className="w-full text-base font-medium rounded-xl py-2.5 transition-colors"
								style={{ backgroundColor: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0' }}
								onClick={() => { this._toggleUncancel(r._id); closePanel() }}
							>
								Restaurer la commande
							</button>
						) : (
							<button
								className="w-full text-white text-base font-medium rounded-xl py-2.5 transition-colors bg-red-500 hover:bg-red-600"
								style={{ backgroundImage: 'none' }}
								onClick={() => { closePanel(); this.setState({ cancelModal: true, cancelTargetId: r._id, cancelClosePanel: null }) }}
							>
								Annuler la commande
							</button>
						)}
					</div>
				</div>
			</>
		)
	}


	openEditModal = (r) => {
		const d = new Date(r.start * 1000)
		d.setHours(0, 0, 0, 0)
		const dayTs = Math.round(d.getTime() / 1000)
		const today = new Date(); today.setHours(0, 0, 0, 0)
		const dow = today.getDay()
		const diffToMonday = (dow === 0) ? -6 : 1 - dow
		const thisMonday = new Date(today); thisMonday.setDate(today.getDate() + diffToMonday)
		const thisMondayTs = Math.round(thisMonday.getTime() / 1000)
		const diffDays = Math.round((dayTs - thisMondayTs) / 86400)
		const weekOffset = Math.floor(diffDays / 7)
		const slotStart = Math.round((r.start - dayTs) / 60)
		const slotEnd = r.end ? Math.round((r.end - dayTs) / 60) : slotStart + 60
		const serviceId = String(typeof r.service === 'object' ? r.service._id : r.service)
		const productPromise = this.props.fetchServiceProductsByService ? this.props.fetchServiceProductsByService(serviceId) : Promise.resolve([])
		const benefitPromise = this.props.fetchServiceBenefitsByService ? this.props.fetchServiceBenefitsByService(serviceId) : Promise.resolve([])
		Promise.all([productPromise, benefitPromise]).then(([products, benefits]) => {
			const benefit = (benefits || []).find(b => b.open_hours && b.open_hours.length > 0) || null
this.setState({
				editModal: true,
				editReservation: r,
				editDay: dayTs,
				editWeekOffset: weekOffset,
				editSlot: { start: slotStart, end: slotEnd },
				editCart: r.cart ? r.cart.map(i => ({ ...i })) : [],
				editProducts: products || [],
				editBenefit: benefit,
					editForm: {
					client_number: r.client_number || '',
					firstname: r.firstname || '',
					lastname: r.lastname || (r.identity ? '' : ''),
					phone: r.phone || '',
					pitch: r.pitch || '',
					comment: r.comment || '',
				},
				editError: null,
			})
		})
	}

	closeEditModal = () => {
		this.setState({ editModal: false, editReservation: null, editDay: null, editWeekOffset: 0, editSlot: null, editCart: [], editProducts: [], editBenefit: null, editForm: { client_number: '', firstname: '', lastname: '', phone: '', pitch: '', comment: '' }, editLoading: false, editError: null })
	}

	submitEdit = () => {
		const { editReservation, editDay, editSlot, editCart, editForm } = this.state
		if (!editReservation) return ;
		if (editCart.length === 0)
		{
			this.setState({ editError: 'Ajoutez au moins un article.' })
			return ;
		}
		const start = (editDay && editSlot) ? editDay + editSlot.start * 60 : editReservation.start
		const end = (editDay && editSlot) ? editDay + editSlot.end * 60 : editReservation.end
		const u = this.props.user
		const editor = u ? ((u.firstname || '') + ' ' + (u.lastname || '')).trim() || u.email || 'Dashboard' : 'Dashboard'
		const newEntry = { at: Math.round(Date.now() / 1000), by: 'dashboard', user: editor }
		const edit_history = [...(editReservation.edit_history || []), newEntry]
		this.setState({ editLoading: true, editError: null })
		this.props.updateServiceReservation(String(editReservation._id), { start, end, cart: editCart, firstname: editForm.firstname, lastname: editForm.lastname, identity: ((editForm.firstname || '') + ' ' + (editForm.lastname || '')).trim(), pitch: editForm.pitch, comment: editForm.comment, phone: editForm.phone, client_number: editForm.client_number, edit_history })
		.then(ret => {
			if (!ret)
			{
				this.setState({ editLoading: false, editError: 'Erreur lors de la modification. Veuillez réessayer.' })
				return ;
			}
			this.closeEditModal()
			this._loadReservations()
		})
		.catch(() => this.setState({ editLoading: false, editError: 'Erreur r\u00e9seau.' }))
	}

	_editCartQty = (articleId) => {
		const item = (this.state.editCart || []).find(i => String(i._id) === String(articleId))
		return item ? (Number(item.quantity) || 0) : 0
	}

	_editCartUpdate = (article, delta) => {
		const editCart = [...(this.state.editCart || [])]
		const id = String(article._id)
		const idx = editCart.findIndex(i => String(i._id) === id)
		if (idx === -1)
		{
			if (delta > 0) this.setState({ editCart: [...editCart, { ...article, quantity: 1 }] })
			return ;
		}
		const newQty = (Number(editCart[idx].quantity) || 0) + delta
		if (newQty <= 0)
			this.setState({ editCart: editCart.filter((_, i) => i !== idx) })
		else
			this.setState({ editCart: editCart.map((item, i) => i === idx ? { ...item, quantity: newQty } : item) })
	}

	_editCartTotal = () => {
		return (this.state.editCart || []).reduce((sum, i) => sum + (Number(i.price) || 0) * (Number(i.quantity) || 0), 0)
	}

	_renderCancelModal = () => {
		if (!this.state.cancelModal) return null
		const { cancelTargetId, cancelClosePanel } = this.state
		const confirmCancel = () => {
			this.setState({ cancelModal: false, cancelTargetId: null, cancelClosePanel: null, cancellingId: String(cancelTargetId) })
			this._cancel(cancelTargetId)
			if (cancelClosePanel) cancelClosePanel()
			setTimeout(() => this.setState({ cancellingId: null }), 1800)
		}
		const dismiss = () => this.setState({ cancelModal: false, cancelTargetId: null, cancelClosePanel: null })
		return (
			<motion.div
				style={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 0.18 }}
			>
				<div
					style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.4)' }}
					onClick={dismiss}
				/>
				<motion.div
					className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 flex flex-col gap-4"
					style={{ position: 'relative', zIndex: 1 }}
					initial={{ opacity: 0, y: 32, scale: 0.95 }}
					animate={{ opacity: 1, y: 0, scale: 1 }}
					transition={{ type: 'spring', stiffness: 380, damping: 30 }}
				>
					<div className="flex flex-col gap-1">
						<p className="text-lg font-bold text-gray-900">Annuler la commande ?</p>
						<p className="text-base text-gray-500">Cette action est irréversible. La commande sera marquée comme annulée.</p>
					</div>
					<div className="flex gap-3">
						<button type="button" onClick={dismiss}
							className="flex-1 text-base font-medium rounded-xl py-3 border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors"
							style={{ backgroundImage: 'none', backgroundColor: 'white' }}
						>
							Non, garder
						</button>
						<button type="button" onClick={confirmCancel}
							className="flex-1 text-white text-base font-medium rounded-xl py-3 bg-red-500 hover:bg-red-600 transition-colors"
							style={{ backgroundImage: 'none' }}
						>
							Oui, annuler
						</button>
					</div>
				</motion.div>
			</motion.div>
		)
	}

	_renderAddModal = () => {
		if (!this.state.addModal) return null
		const { addStep, addService, addBenefit, addDay, addSlot, addCart, addProducts, addForm, addError, addSuccess, addLoading, addWeekOffset } = this.state
		const venteServices = this._getVenteServices()
		const inputClass = "pck-input browser-default w-full border border-slate-200 rounded-2xl px-4 py-3.5 text-base bg-white transition-all"
		const inputStyle = { border: '1px solid #e2e8f0', borderRadius: '16px', padding: '14px 16px', boxShadow: 'none', height: 'auto', margin: 0, backgroundColor: 'white', boxSizing: 'border-box' }
		const labelClass = "block text-base font-medium text-gray-700 mb-2"
		const STEPS = ['Service', 'Créneau', 'Panier', 'Client']
		const DAY_SHORT = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']

		const getServiceName = (s) => {
			const lang = this.props.lang_default || 'fr'
			const t = (s.translations || []).find(t => t.lang === lang) || (s.translations || [])[0]
			return t ? (t.title || t.subtitle || s.name || '') : (s.name || '')
		}

		const getArticleName = (a) => {
			const lang = this.props.lang_default || 'fr'
			const t = (a.translations || []).find(t => t.lang === lang) || (a.translations || [])[0]
			return t ? (t.title || t.subtitle || t.name || 'Article') : 'Article'
		}

		return (
			<>
				<style>{`.pck-input:focus { border-color: #3b82f6 !important; box-shadow: 0 0 0 3px rgba(59,130,246,0.12) !important; outline: none !important; }`}</style>
				<div className="fixed inset-0 bg-black/40 z-40" />
				<div className="fixed inset-0 flex items-end sm:items-center justify-center z-50 sm:p-4">
					<div className="bg-white rounded-t-3xl sm:rounded-3xl shadow-2xl w-full sm:max-w-2xl flex flex-col" style={{ height: '92vh' }}>

						{/* Header */}
						<div className="flex items-center justify-between px-6 pt-6 pb-3 shrink-0">
							<div className="flex items-center gap-2">
								{addStep > 1 && (
									<button onClick={() => this.setState({ addStep: addStep - 1, addError: null })} className="text-gray-400 hover:text-gray-700 text-xl leading-none mr-1">←</button>
								)}
								<h2 className="text-base font-semibold text-gray-900">{STEPS[addStep - 1]}</h2>
							</div>
							<button onClick={this.closeAddModal} className="text-gray-400 hover:text-gray-700 text-xl leading-none">✕</button>
						</div>

						{/* Barre de progression */}
						<div className="flex gap-2 px-6 pb-5 shrink-0">
							{STEPS.map((_, i) => (
								<div key={i} className={`h-1 rounded-full flex-1 transition-all ${i < addStep ? 'bg-indigo-600' : 'bg-gray-200'}`} />
							))}
						</div>

						{/* Contenu */}
						<div className="flex-1 overflow-y-auto">

							{/* ── Étape 1 : Service ── */}
							{addStep === 1 && (
								<div className="px-6 pb-6 space-y-3">
									<p className="text-base text-gray-400 pb-2">Sélectionnez un service pour continuer.</p>
									{venteServices.length === 0
										? <p className="text-base text-gray-400 text-center py-8">Aucun service boutique configuré.</p>
										: venteServices.map(s => (
											<button key={s._id} type="button" onClick={() => this.selectAddService(s)}
												className="w-full text-left border border-gray-200 rounded-2xl px-5 py-5 hover:border-indigo-400 hover:bg-indigo-50 transition-all">
												<p className="text-base font-semibold text-gray-900">{getServiceName(s)}</p>
												{s.name && <p className="text-sm text-gray-400 mt-0.5">{s.name}</p>}
											</button>
										))
									}
								</div>
							)}

							{/* ── Étape 2 : Créneau ── */}
							{addStep === 2 && addService && (() => {
								const weekDays = this._getAddWeekDays()
								const todayMidnight = (() => { const d = new Date(); d.setHours(0,0,0,0); return Math.round(d.getTime() / 1000) })()
								const slots = (addBenefit && addDay) ? this._generateSlotsForModal(addBenefit, addDay) : []
								const fmtWeekRange = () => {
									const fmt = (ts) => { const d = new Date(ts * 1000); return d.getDate() + ' ' + ['jan','’fév','mar','avr','mai','jun','jul','aoû','sep','oct','nov','déc'][d.getMonth()] }
									return fmt(weekDays[0]) + ' – ' + fmt(weekDays[6])
								}
								return (
									<div className="px-6 pb-6">
										<div className="mb-4 px-3 py-2 bg-indigo-50 rounded-xl text-base flex items-center justify-between">
											<span className="font-medium text-indigo-700">{getServiceName(addService)}</span>
											{addDay && <span className="text-sm text-indigo-400 ml-3 shrink-0">{this._formatDayFull(addDay)}</span>}
										</div>
										{!addBenefit
											? (
												<div className="text-center py-8">
													<p className="text-base text-gray-400 mb-4">Aucun créneau configuré pour ce service.</p>
													<button type="button" onClick={() => this.setState({ addStep: 3 })}
														className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-indigo-50 text-indigo-700 text-base font-medium hover:bg-indigo-100 transition-colors">
														Continuer sans créneau →
													</button>
												</div>
											)
											: (
												<>
													{!addDay && <p className="text-base text-gray-400 pb-1">Sélectionnez un créneau pour continuer.</p>}
													{/* Navigation semaine */}
													<div className="flex items-center justify-between mb-3">
														<button onClick={() => this.setState({ addWeekOffset: addWeekOffset - 1, addDay: null, addSlot: null })} className="p-2 text-gray-400 hover:text-gray-700 text-lg leading-none">‹</button>
														<span className="text-base font-medium text-gray-600">{fmtWeekRange()}</span>
														<button onClick={() => this.setState({ addWeekOffset: addWeekOffset + 1, addDay: null, addSlot: null })} className="p-2 text-gray-400 hover:text-gray-700 text-lg leading-none">›</button>
													</div>
													{/* Strip des jours */}
													<div className="flex gap-1.5 mb-5">
														{weekDays.map(dayTs => {
															const d = new Date(dayTs * 1000)
															const isToday = dayTs === todayMidnight
															const isSelected = dayTs === addDay
															const isPast = dayTs < todayMidnight
															const hasSlots = this._generateSlotsForModal(addBenefit, dayTs).length > 0
															return (
																<button key={dayTs} type="button" onClick={() => { if (!isPast) this.selectAddDay(dayTs) }}
																	className={`flex-1 flex flex-col items-center py-3 pb-2.5 rounded-2xl border transition-all ${isPast ? 'text-gray-300 border-gray-100 cursor-not-allowed' : isSelected ? 'bg-indigo-600 text-white border-indigo-600' : isToday ? 'bg-indigo-50 text-indigo-700 border-indigo-200' : 'text-gray-600 hover:bg-gray-100 border-gray-200'}`}>
																	<span className="text-sm font-medium">{DAY_SHORT[d.getDay()]}</span>
																	<span className="text-base font-bold mt-0.5">{d.getDate()}</span>
																	<span className="mt-1 h-1.5 w-1.5 rounded-full" style={{ backgroundColor: hasSlots ? (isSelected ? 'rgba(255,255,255,0.8)' : '#6366f1') : 'transparent' }} />
																</button>
															)
														})}
													</div>
													{/* Créneaux */}
													{!addDay
														? <p className="text-base text-gray-400 text-center py-6">Sélectionnez un jour.</p>
														: slots.length === 0
															? (() => {
																const nextDay = this._findNextAvailableDay(addBenefit, addDay)
																const fmtNext = nextDay ? (() => {
																	const d = new Date(nextDay * 1000)
																	const months = ['jan.','’fév.','mars','avr.','mai','juin','juil.','août','sep.','oct.','nov.','déc.']
																	return d.getDate() + ' ' + months[d.getMonth()]
																})() : null
																return (
																	<div className="text-center py-6">
																		<p className="text-base text-gray-400 mb-3">Aucun créneau disponible ce jour.</p>
																		{nextDay && (
																			<button type="button" onClick={() => this._goToNextAvailableDay(nextDay)}
																				className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-indigo-50 text-indigo-700 text-base font-medium hover:bg-indigo-100 transition-colors">
																				Prochain créneau : {fmtNext} →
																			</button>
																		)}
																	</div>
																)
															})()
															: <div className="space-y-2">
																{slots.map((slot, i) => (
																	<button key={i} type="button" onClick={() => this.selectAddSlot(slot)}
																		className="w-full flex items-center gap-3 px-4 py-4 border border-gray-200 rounded-2xl text-left transition-all hover:border-indigo-400 hover:bg-indigo-50">
																		<span className="text-base font-semibold text-gray-800 shrink-0 w-20">
																			{this._formatTime(addDay + slot.start * 60)}
																		</span>
																		<span className="text-base text-gray-400 shrink-0">→ {this._formatTime(addDay + slot.end * 60)}</span>
																	</button>
																))}
															</div>
													}
												</>
											)
										}
									</div>
								)
							})()}

							{/* ── Étape 3 : Panier ── */}
							{addStep === 3 && (
								<div className="px-6 pb-6">
									{addService && addDay && addSlot && (
										<div className="mb-4 px-3 py-2 bg-indigo-50 rounded-xl text-base text-indigo-700 flex items-center gap-2 flex-wrap">
											<span className="font-medium">{getServiceName(addService)}</span>
											<span className="text-indigo-300">·</span>
											<span>{this._formatDayFull(addDay)} · {this._formatTime(addDay + addSlot.start * 60)}</span>
										</div>
									)}
									<p className="text-base text-gray-400 pb-3">Sélectionnez les articles à commander.</p>
									{addProducts.length === 0
										? <p className="text-base text-gray-400 text-center py-8">Aucun article configuré pour ce service.</p>
										: (
											<div className="space-y-4">
												{addProducts.map(article => {
													const qty = this._cartQty(article._id)
													const name = getArticleName(article)
													const price = Number(article.price) || 0
													return (
														<div key={article._id} className="flex items-center justify-between border border-gray-200 rounded-2xl px-4 py-3">
															<div className="min-w-0 flex-1">
																<p className="text-base font-semibold text-gray-900 truncate">{name}</p>
																{price > 0 && <p className="text-sm text-gray-400">{this._formatEur(price)}</p>}
															</div>
															<div className="flex items-center gap-3 shrink-0 ml-3">
																<button
																	type="button"
																	onClick={() => this._cartUpdate(article, -1)}
																	disabled={qty === 0}
																	className={`w-9 h-9 rounded-full flex items-center justify-center text-lg font-bold transition-colors ${qty > 0 ? 'bg-gray-100 text-gray-600 hover:bg-gray-200' : 'bg-gray-50 text-gray-300 cursor-not-allowed'}`}
																>−</button>
																<span className="w-6 text-center text-base font-bold text-gray-900">{qty}</span>
																<button
																	type="button"
																	onClick={() => this._cartUpdate(article, 1)}
																	className="w-9 h-9 rounded-full flex items-center justify-center text-lg font-bold bg-indigo-600 text-white hover:bg-indigo-700 transition-colors"
																>+</button>
															</div>
														</div>
													)
												})}
										</div>
										)
									}
									{addCart.length > 0 && (
										<div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
											<p className="text-base font-semibold text-gray-700">Total</p>
											<p className="text-lg font-black text-gray-900">{this._formatEur(this._cartTotal())}</p>
										</div>
									)}
								</div>
							)}

							{/* ── Étape 4 : Client ── */}
							{addStep === 4 && (
								<div className="px-6 pb-6">
									{addService && (
										<div className="mb-4 px-3 py-2.5 bg-indigo-50 rounded-xl text-base text-indigo-700 flex items-center gap-2 flex-wrap">
											<span className="font-medium">{getServiceName(addService)}</span>
											{addDay && addSlot && (
												<>
													<span className="text-indigo-300">·</span>
													<span>{this._formatDayFull(addDay)} · {this._formatTime(addDay + addSlot.start * 60)}</span>
												</>
											)}
										</div>
									)}
									{addSuccess && <div className="mb-3 p-3 bg-green-50 border border-green-200 rounded-xl text-base text-green-700">{addSuccess}</div>}
									{addError && <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-xl text-base text-red-700">{addError}</div>}
									<form onSubmit={this.submitAddCommande} className="space-y-4">
										<div className="flex gap-3">
											<div className="flex-1">
												<label className={labelClass}>Numéro client <span className="text-gray-400 font-normal">(opt.)</span></label>
												<input className={inputClass} style={inputStyle} value={addForm.client_number}
													onChange={e => { this.setState({ addForm: { ...addForm, client_number: e.target.value } }); this._lookupAddClient(e.target.value) }}
													placeholder="ex: 42" />
											</div>
											<div className="flex-1">
												<label className={labelClass}>Emplacement <span className="text-gray-400 font-normal">(opt.)</span></label>
												<input className={inputClass} style={inputStyle} value={addForm.pitch}
													onChange={e => this.setState({ addForm: { ...addForm, pitch: e.target.value } })}
													placeholder="ex: A12" />
											</div>
										</div>
										<div className="flex gap-3">
											<div className="flex-1">
												<label className={labelClass}>Prénom</label>
												<input className={inputClass} style={inputStyle} value={addForm.firstname}
													onChange={e => this.setState({ addForm: { ...addForm, firstname: e.target.value } })}
													placeholder="ex: Marie" />
											</div>
											<div className="flex-1">
												<label className={labelClass}>Nom</label>
												<input className={inputClass} style={inputStyle} value={addForm.lastname}
													onChange={e => this.setState({ addForm: { ...addForm, lastname: e.target.value } })}
													placeholder="ex: Dupont" />
											</div>
										</div>
										<div>
											<label className={labelClass}>Téléphone <span className="text-gray-400 font-normal">(optionnel)</span></label>
											<input className={inputClass} style={inputStyle} value={addForm.phone}
												onChange={e => this.setState({ addForm: { ...addForm, phone: e.target.value } })}
												placeholder="ex: 06 12 34 56 78" />
										</div>
										<div>
											<label className={labelClass}>Commentaire <span className="text-gray-400 font-normal">(optionnel)</span></label>
											<textarea className={inputClass} value={addForm.comment} rows={4}
												onChange={e => this.setState({ addForm: { ...addForm, comment: e.target.value } })}
												placeholder="Notes libres..." style={{ border: '1px solid #e2e8f0', borderRadius: '16px', padding: '14px 16px', boxShadow: 'none', minHeight: '110px', margin: 0, backgroundColor: 'white', boxSizing: 'border-box', resize: 'none' }} />
										</div>
										{addBenefit && (addBenefit.questions || []).map((q, idx) => {
											let title = ''
											for (const t of (q.translations || []))
												if (t.lang === (this.props.lang_default || 'fr')) { title = t.title; break }
											if (q.mandatory) title += ' *'
											return (
												<div key={idx}>
													<label className={labelClass}>{title}</label>
													<input className={inputClass} style={inputStyle}
														value={addForm.answers[idx] || ''}
														onChange={e => {
															const answers = [...addForm.answers]
															answers[idx] = e.target.value
															this.setState({ addForm: { ...addForm, answers } })
														}} />
												</div>
											)
										})}
										<div className="pt-2">
											<button type="submit" disabled={addLoading || addCart.length === 0}
												className="w-full bg-indigo-600 hover:bg-indigo-700 text-white text-lg font-medium rounded-2xl py-4 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
												{addLoading ? 'Enregistrement...' : 'Enregistrer la commande'}
											</button>
										</div>
									</form>
								</div>
							)}

						</div>

						{/* Footer CTA étape 3 */}
						{addStep === 3 && addCart.length > 0 && (
							<div className="px-6 py-5 border-t border-gray-100 shrink-0">
								<button type="button"
									onClick={() => this.setState({ addStep: 4, addError: null })}
									className="w-full bg-indigo-600 hover:bg-indigo-700 text-white text-base font-medium rounded-xl py-3 transition-colors">
									Continuer →
								</button>
							</div>
						)}

					</div>
				</div>
			</>
		)
	}


	_renderEditModal = () => {
		if (!this.state.editModal) return null
		const { editDay, editWeekOffset, editSlot, editCart, editProducts, editBenefit, editForm, editLoading, editError } = this.state
		const inputClass = "pck-input browser-default w-full border border-slate-200 rounded-2xl px-4 py-3.5 text-base bg-white transition-all"
		const inputStyle = { border: '1px solid #e2e8f0', borderRadius: '16px', padding: '14px 16px', boxShadow: 'none', height: 'auto', margin: 0, backgroundColor: 'white', boxSizing: 'border-box' }
		const labelClass = "block text-base font-medium text-gray-700 mb-2"
		const DAY_SHORT = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']

		const getArticleName = (a) => {
			const lang = this.props.lang_default || 'fr'
			const t = (a.translations || []).find(t => t.lang === lang) || (a.translations || [])[0]
			return t ? (t.title || t.subtitle || t.name || 'Article') : 'Article'
		}

		const today = new Date(); today.setHours(0, 0, 0, 0)
		const todayMidnight = Math.round(today.getTime() / 1000)
		const dow = today.getDay()
		const diffToMonday = (dow === 0) ? -6 : 1 - dow
		const monday = new Date(today); monday.setDate(today.getDate() + diffToMonday + editWeekOffset * 7)
		const weekDays = []
		for (let i = 0; i < 7; i++) {
			const d = new Date(monday); d.setDate(monday.getDate() + i); d.setHours(0, 0, 0, 0)
			weekDays.push(Math.round(d.getTime() / 1000))
		}
		const slots = (editBenefit && editDay) ? this._generateSlotsForModal(editBenefit, editDay) : []
		const fmt = (ts) => { const d = new Date(ts * 1000); return d.getDate() + ' ' + ['jan','f\u00e9v','mar','avr','mai','jun','jul','ao\u00fb','sep','oct','nov','d\u00e9c'][d.getMonth()] }
		const weekRange = fmt(weekDays[0]) + ' \u2013 ' + fmt(weekDays[6])

		return (
			<>
				<style>{`.pck-input:focus { border-color: #3b82f6 !important; box-shadow: 0 0 0 3px rgba(59,130,246,0.12) !important; outline: none !important; }`}</style>
				<div className="fixed inset-0 bg-black/40 z-40" />
				<div className="fixed inset-0 flex items-end sm:items-center justify-center z-50 sm:p-4">
					<div className="bg-white rounded-t-3xl sm:rounded-3xl shadow-2xl w-full sm:max-w-2xl flex flex-col" style={{ height: '92vh' }}>

						{/* Header */}
						<div className="flex items-center justify-between px-6 pt-6 pb-4 shrink-0 border-b border-gray-100">
							<p className="text-lg font-bold text-gray-900">Modifier la commande</p>
							<button type="button" onClick={this.closeEditModal} className="text-gray-400 hover:text-gray-700 text-xl leading-none" style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}>×</button>
						</div>

						{/* Body */}
						<div className="overflow-y-auto flex-1 px-6 py-6 space-y-7">

							{/* — Créneau — */}
							{editBenefit && (
								<div>
									<p className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-3">Créneau</p>
									{editDay && (
										<div className="mb-3 px-3 py-2 bg-amber-50 rounded-xl text-lg text-amber-700 font-bold">{this._formatDayFull(editDay)}{editSlot ? ' · ' + this._formatTime(editDay + editSlot.start * 60) + ' \u2192 ' + this._formatTime(editDay + editSlot.end * 60) : ''}</div>
									)}
									<div className="flex items-center justify-between mb-3">
										<button type="button" onClick={() => this.setState({ editWeekOffset: editWeekOffset - 1, editDay: null, editSlot: null })} className="p-2 text-gray-400 hover:text-gray-700 text-lg leading-none" style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}>‹</button>
										<span className="text-sm font-medium text-gray-600">{weekRange}</span>
										<button type="button" onClick={() => this.setState({ editWeekOffset: editWeekOffset + 1, editDay: null, editSlot: null })} className="p-2 text-gray-400 hover:text-gray-700 text-lg leading-none" style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}>›</button>
									</div>
									<div className="flex gap-1.5 mb-4">
										{weekDays.map(dayTs => {
											const d = new Date(dayTs * 1000)
											const isSelected = dayTs === editDay
											const isToday = dayTs === todayMidnight
											const isPast = dayTs < todayMidnight
											const hasSlots = this._generateSlotsForModal(editBenefit, dayTs).length > 0
											return (
												<button key={dayTs} type="button"
													onClick={() => { if (!isPast) this.setState({ editDay: dayTs, editSlot: null }) }}
													className={'flex-1 flex flex-col items-center py-3 pb-2.5 rounded-2xl border transition-all ' + (isPast ? 'text-gray-300 border-gray-100 cursor-not-allowed' : isSelected ? 'bg-indigo-600 text-white border-indigo-600' : isToday ? 'bg-indigo-50 text-indigo-700 border-indigo-200' : 'text-gray-600 hover:bg-gray-100 border-gray-200')}
													style={{ backgroundImage: 'none' }}
												>
													<span className="text-sm font-medium">{DAY_SHORT[d.getDay()]}</span>
													<span className="text-base font-bold mt-0.5">{d.getDate()}</span>
													<span className="mt-1 h-1.5 w-1.5 rounded-full" style={{ backgroundColor: hasSlots ? (isSelected ? 'rgba(255,255,255,0.8)' : '#6366f1') : 'transparent' }} />
												</button>
											)
										})}
									</div>
									{editDay && (
										<div className="space-y-2">
											{slots.length === 0
												? <p className="text-sm text-gray-400 text-center py-4">Aucun créneau disponible ce jour.</p>
												: slots.map((slot, i) => (
													<button key={i} type="button"
														onClick={() => this.setState({ editSlot: slot })}
														className={'w-full flex items-center gap-3 px-4 py-4 border rounded-2xl text-left transition-all ' + (editSlot && editSlot.start === slot.start ? 'border-indigo-500 bg-indigo-50' : 'border-gray-200 hover:border-indigo-400 hover:bg-indigo-50')}
														style={{ backgroundImage: 'none' }}
													>
														<span className="text-sm font-semibold text-gray-800 shrink-0 w-20">{this._formatTime(editDay + slot.start * 60)}</span>
														<span className="text-sm text-gray-400">→ {this._formatTime(editDay + slot.end * 60)}</span>
													</button>
												))
											}
										</div>
									)}
								</div>
							)}

							{/* — Panier — */}
							<div>
								<p className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-3">Panier</p>
								{editProducts.length === 0
									? <p className="text-sm text-gray-400">Aucun article configuré.</p>
									: (
										<div className="space-y-4">
											{editProducts.map(article => {
												const qty = this._editCartQty(article._id)
												const price = Number(article.price) || 0
												return (
													<div key={article._id} className="flex items-center justify-between border border-gray-200 rounded-2xl px-4 py-3">
														<div className="min-w-0 flex-1">
															<p className="text-sm font-semibold text-gray-900 truncate">{getArticleName(article)}</p>
															{price > 0 && <p className="text-xs text-gray-400">{this._formatEur(price)}</p>}
														</div>
														<div className="flex items-center gap-3 shrink-0 ml-3">
															<button type="button" onClick={() => this._editCartUpdate(article, -1)} disabled={qty === 0}
																className={'w-9 h-9 rounded-full flex items-center justify-center text-lg font-bold transition-colors ' + (qty > 0 ? 'bg-gray-100 text-gray-600 hover:bg-gray-200' : 'bg-gray-50 text-gray-300 cursor-not-allowed')}
																style={{ backgroundImage: 'none', backgroundColor: qty > 0 ? '#f3f4f6' : '#f9fafb' }}
															>−</button>
															<span className="w-6 text-center text-sm font-bold text-gray-900">{qty}</span>
															<button type="button" onClick={() => this._editCartUpdate(article, 1)}
																className="w-9 h-9 rounded-full flex items-center justify-center text-lg font-bold transition-colors"
																style={{ backgroundImage: 'none', backgroundColor: '#4f46e5', color: 'white' }}
															>+</button>
														</div>
													</div>
												)
											})}
											{editCart.length > 0 && (
												<div className="pt-3 border-t border-gray-100 flex items-center justify-between">
													<p className="text-sm font-semibold text-gray-700">Total</p>
													<p className="text-base font-black text-gray-900">{this._formatEur(this._editCartTotal())}</p>
												</div>
											)}
										</div>
									)
								}
							</div>

							{/* — Client — */}
							<div>
								<p className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-3">Client</p>
								<div className="space-y-4">
									<div className="flex gap-3">
										<div className="flex-1">
											<label className={labelClass}>Numéro client <span className="text-gray-400 font-normal">(opt.)</span></label>
											<input className={inputClass} style={inputStyle} value={editForm.client_number}
												onChange={e => this.setState({ editForm: { ...editForm, client_number: e.target.value } })}
												placeholder="ex: 42" />
										</div>
										<div className="flex-1">
											<label className={labelClass}>Emplacement <span className="text-gray-400 font-normal">(opt.)</span></label>
											<input className={inputClass} style={inputStyle} value={editForm.pitch}
												onChange={e => this.setState({ editForm: { ...editForm, pitch: e.target.value } })}
												placeholder="ex: A12" />
										</div>
									</div>
									<div className="flex gap-3">
										<div className="flex-1">
											<label className={labelClass}>Prénom</label>
											<input className={inputClass} style={inputStyle} value={editForm.firstname}
												onChange={e => this.setState({ editForm: { ...editForm, firstname: e.target.value } })}
												placeholder="ex: Marie" />
										</div>
										<div className="flex-1">
											<label className={labelClass}>Nom</label>
											<input className={inputClass} style={inputStyle} value={editForm.lastname}
												onChange={e => this.setState({ editForm: { ...editForm, lastname: e.target.value } })}
												placeholder="ex: Dupont" />
										</div>
									</div>
									<div>
										<label className={labelClass}>Téléphone <span className="text-gray-400 font-normal">(optionnel)</span></label>
										<input className={inputClass} style={inputStyle} value={editForm.phone}
											onChange={e => this.setState({ editForm: { ...editForm, phone: e.target.value } })}
											placeholder="ex: 06 12 34 56 78" />
									</div>
									<div>
										<label className={labelClass}>Commentaire <span className="text-gray-400 font-normal">(optionnel)</span></label>
										<textarea className={inputClass} value={editForm.comment} rows={4}
											onChange={e => this.setState({ editForm: { ...editForm, comment: e.target.value } })}
											placeholder="Notes libres..." style={{ border: '1px solid #e2e8f0', borderRadius: '16px', padding: '14px 16px', boxShadow: 'none', minHeight: '110px', margin: 0, backgroundColor: 'white', boxSizing: 'border-box', resize: 'none' }} />
									</div>
								</div>
							</div>

							{editError && <div className="p-3 bg-red-50 border border-red-200 rounded-xl text-sm text-red-700">{editError}</div>}

						</div>

						{/* Footer */}
						<div className="px-6 py-5 border-t border-gray-100 shrink-0">
							<button type="button" onClick={this.submitEdit} disabled={editLoading}
								className="w-full text-white text-lg font-medium rounded-2xl py-4 transition-colors disabled:opacity-50"
								style={{ backgroundImage: 'none', backgroundColor: '#4f46e5' }}
							>
								{editLoading ? 'Enregistrement...' : 'Enregistrer les modifications'}
							</button>
						</div>

					</div>
				</div>
			</>
		)
	}

	render() {
		const { loading } = this.state

		if (this.props.features !== 'premium') {
			return (
				<>
					<OnlyPremiumEmpty
						title="Commandes"
						subtitle="Suivez et encaissez les commandes de vos services de vente"
						emptyFolder="Commencez par créer un service"
						emptyFolderSubtitle="Pas de commandes"
						navName="Services"
						navPath="/Services"
					/>
					<div className="mt-10">
						<PremiumAlert
							content="Mettez votre abonnement à niveau avec la formule premium pour accéder aux services !"
							button_text="En savoir plus"
						/>
					</div>
				</>
			)
		}

		return (
			<div>
				<ServiceSubPageHeader
					onBack={() => this.props.history.push('/services')}
					user={this.props.user}
				/>
				<div className="space-y-6 py-6">
					{this._renderTitleRow()}
					{loading ? (
						<div className="flex justify-center items-center py-24 text-gray-400 text-sm">Chargement…</div>
					) : (
						<>
							{this._renderRecap()}
							{this._renderFilters()}
							{this._renderCreneaux()}
						</>
					)}
				</div>
				{this._renderAddModal()}
			{this._renderEditModal()}
			{this._renderCancelModal()}
			{this._renderPanel()}
			</div>
		)
	}
}

export default ServiceCommandesAll
